export enum PaymentOwnerTypes {
   Blok = 'blok',
}
